import type { CombinedState, Reducer } from 'redux';
import { combineReducers } from 'redux';
import type { SynchronyStateType } from '../support/synchrony-support/reducer.ts';
import synchrony from '../support/synchrony-support/reducer.ts';
import type { ViewState } from './views/index.ts';
import views from './views/index.ts';
import type { DraftStateType } from './views/draft.ts';
import type { EditorContentV2Type } from './views/editorContentV2.ts';

export type RootState = {
	fabricEditor: {
		views: ViewState;
		synchrony: SynchronyStateType;
	};
	entities: any;
	router: any;
	views: {
		viewPage: {
			labels: any;
		};
	};
};

const _default_1: Reducer<
	CombinedState<{
		synchrony: SynchronyStateType;
		views: CombinedState<{
			editorContentV2: Readonly<EditorContentV2Type>;
			mediaPreviewer: {
				currentMediaItem: null;
				isOpen: boolean;
			};
			draft: DraftStateType;
		}>;
	}>,
	any
> = combineReducers({
	synchrony,
	views,
});
export default _default_1;
